import React, { Component } from 'react';
import { Button, Card, CardActionArea, Typography, Stack } from '@mui/material';
import WithRouter from '../Layout/Router/WithRouter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class PageNavigationCard extends Component {
  render() {
    const { subPage, id, url, header, cardClass } = this.props;
    return (
      <Card
        className={`myOdu__pageNavigationCard ${cardClass}`}
        elevation="0"
        onClick={() => this.props.navigate(`/${url}/${subPage.page}`)}
        id={`card_${id}_${subPage.page}`}
      >
        <Stack direction="row" justify-content="flex-start" alignItems="flex-start" spacing={2}>
          <div className="icon">
            <FontAwesomeIcon icon={subPage.icon} size="xl" />
          </div>
          <Stack justify-content="flex-start">
            <Typography component={header}>{subPage.title}</Typography>
            <Typography variant="p" align="left">
              {subPage.description}
            </Typography>
          </Stack>
        </Stack>
      </Card>
    );
  }
}

export default WithRouter(PageNavigationCard);
